import { render, staticRenderFns } from "./favorite-active-svg.vue?vue&type=template&id=6d5aa208&scoped=true"
import script from "./favorite-active-svg.vue?vue&type=script&lang=js"
export * from "./favorite-active-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5aa208",
  null
  
)

export default component.exports